
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NavigationSidebar',
  methods: {
    logout: function () {
      this.$store.dispatch('logout');
    }
  }
});
